export default "__VITE_ASSET__CySTaPwV__"